<template>
  <section class="fe-cart-page">
    <div class="container fe-cart-page__inner">
      <!-- Empty cart -->
      <div v-if="cartStore.cart_products.length === 0" class="fe-cart-empty">
        <div class="fe-cart-empty__icon" aria-hidden="true">
          <i class="fas fa-shopping-bag"></i>
        </div>
        <h2 class="fe-cart-empty__title">Your cart is empty</h2>
        <p class="fe-cart-empty__text">Add items from the shop to see them here.</p>
        <router-link to="/shop" class="fe-btn fe-btn--primary"> Continue shopping </router-link>
      </div>

      <!-- Cart with items -->
      <div v-else class="fe-cart-layout">
        <div class="fe-cart-card fe-cart-card--table">
          <div class="fe-cart-card__head">
            <h2 class="fe-cart-card__title">Shopping cart</h2>
            <span class="fe-cart-card__badge">{{ cartStore.cart_products.length }} item(s)</span>
          </div>
          <div class="table-responsive fe-cart-table-wrap">
            <table class="table fe-cart-table mb-0">
              <thead>
                <tr>
                  <th class="fe-cart-th fe-cart-th--img">Product</th>
                  <th class="fe-cart-th fe-cart-th--hide-sm">Unit price</th>
                  <th class="fe-cart-th fe-cart-th--qty">Qty</th>
                  <th class="fe-cart-th fe-cart-th--hide-sm text-end">Total</th>
                  <th class="fe-cart-th fe-cart-th--rm"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in cartStore.cart_products" :key="item.id">
                  <td class="fe-cart-td fe-cart-td--product" data-label="Product">
                    <div class="fe-cart-product">
                      <router-link :to="`/shop-details/${item.id}`" class="fe-cart-product__img-wrap">
                        <img
                          v-if="item.image"
                          :src="item.image"
                          :alt="item.title || 'Product'"
                          class="fe-cart-product__img"
                        />
                        <span v-else class="fe-cart-product__ph"><i class="fas fa-image"></i></span>
                      </router-link>
                      <div class="fe-cart-product__meta">
                        <router-link :to="`/shop-details/${item.id}`" class="fe-cart-product__name">
                          {{ item.title }}
                        </router-link>
                        <span class="fe-cart-product__price-sm d-md-none">
                          LKR {{ Number(item.price).toFixed(2) }}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td class="fe-cart-td d-none d-md-table-cell" data-label="Unit price">
                    <span class="fe-cart-money">LKR {{ Number(item.price).toFixed(2) }}</span>
                  </td>
                  <td class="fe-cart-td fe-cart-td--qty" data-label="Quantity">
                    <div class="fe-qty">
                      <button
                        type="button"
                        class="fe-qty__btn"
                        aria-label="Decrease quantity"
                        @click="cartStore.quantityDecrement(item)"
                      >
                        −
                      </button>
                      <input
                        v-model.number="item.orderQuantity"
                        type="number"
                        class="fe-qty__input"
                        min="1"
                      />
                      <button
                        type="button"
                        class="fe-qty__btn"
                        aria-label="Increase quantity"
                        @click="cartStore.addCartProduct(item)"
                      >
                        +
                      </button>
                    </div>
                  </td>
                  <td class="fe-cart-td text-end d-none d-md-table-cell" data-label="Total">
                    <span class="fe-cart-money fe-cart-money--strong">
                      LKR {{ (Number(item.price) * (item.orderQuantity || 1)).toFixed(2) }}
                    </span>
                  </td>
                  <td class="fe-cart-td fe-cart-td--rm text-center">
                    <button
                      type="button"
                      class="fe-cart-remove"
                      aria-label="Remove item"
                      @click="cartStore.removeCartProduct(item)"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <aside class="fe-cart-summary">
          <div class="fe-cart-card fe-cart-card--summary">
            <h3 class="fe-cart-summary__title">Order summary</h3>
            <ul class="fe-cart-summary__lines">
              <li class="fe-cart-summary__row">
                <span>Subtotal</span>
                <span class="fe-cart-money">LKR {{ cartStore.totalPriceQuantity.total.toFixed(2) }}</span>
              </li>
              <li class="fe-cart-summary__row fe-cart-summary__row--total">
                <span>Total</span>
                <span class="fe-cart-money fe-cart-money--lg">
                  LKR {{ cartStore.totalPriceQuantity.total.toFixed(2) }}
                </span>
              </li>
            </ul>
            <router-link to="/checkout" class="fe-btn fe-btn--primary fe-btn--block">
              Proceed to checkout
              <i class="fas fa-arrow-right"></i>
            </router-link>
            <router-link to="/shop" class="fe-btn fe-btn--ghost fe-btn--block"> Continue shopping </router-link>
          </div>
        </aside>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'
import { useCartStore } from '@/stores/useCartStore'

export default {
  name: 'CartArea',
  setup() {
    const cartStore = useCartStore()
    const couponCode = ref('')

    const handleCouponSubmit = () => {
      console.log(couponCode.value)
    }

    return {
      cartStore,
      couponCode,
      handleCouponSubmit,
    }
  },
}
</script>

<style scoped>
.fe-cart-page {
  padding: 3rem 0 4.5rem;
  background: linear-gradient(180deg, #f8f9fb 0%, #fff 48%);
}

.fe-cart-page__inner {
  max-width: 1200px;
}

/* Empty state */
.fe-cart-empty {
  text-align: center;
  padding: 3.5rem 1.5rem;
  background: #fff;
  border-radius: 20px;
  border: 1px solid #eceef2;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.06);
}

.fe-cart-empty__icon {
  width: 88px;
  height: 88px;
  margin: 0 auto 1.25rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: color-mix(in srgb, var(--fe-accent, #fcbe00) 85%, #333);
  background: color-mix(in srgb, var(--fe-accent, #fcbe00) 14%, #fff);
}

.fe-cart-empty__title {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #141414;
  margin: 0 0 0.5rem;
}

.fe-cart-empty__text {
  margin: 0 0 1.75rem;
  color: #64748b;
  font-size: 0.95rem;
}

/* Layout */
.fe-cart-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: start;
}

@media (min-width: 992px) {
  .fe-cart-layout {
    grid-template-columns: 1fr min(360px, 34%);
  }
}

/* Cards */
.fe-cart-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid #e8ecf1;
  box-shadow: 0 10px 36px rgba(15, 23, 42, 0.07);
  overflow: hidden;
}

.fe-cart-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.15rem 1.35rem;
  border-bottom: 1px solid #eef1f5;
  background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
}

.fe-cart-card__title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.fe-cart-card__badge {
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--fe-accent, #fcbe00) 16%, #fff);
  color: #5c4a00;
}

.fe-cart-table-wrap {
  margin: 0;
}

.fe-cart-table {
  margin: 0;
  font-size: 0.92rem;
}

.fe-cart-table thead th {
  background: #f8fafc;
  border-bottom: 1px solid #eef1f5;
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  padding: 0.85rem 1rem;
  white-space: nowrap;
}

.fe-cart-table tbody td {
  padding: 1rem;
  vertical-align: middle;
  border-color: #f1f5f9;
  color: #334155;
}

.fe-cart-th--rm {
  width: 52px;
}

.fe-cart-product {
  display: flex;
  align-items: center;
  gap: 1rem;
  text-align: left;
}

.fe-cart-product__img-wrap {
  flex-shrink: 0;
  width: 88px;
  height: 88px;
  border-radius: 12px;
  overflow: hidden;
  background: #f1f5f9;
  border: 1px solid #e8ecf1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fe-cart-product__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fe-cart-product__ph {
  color: #94a3b8;
  font-size: 1.25rem;
}

.fe-cart-product__name {
  font-weight: 700;
  color: #0f172a;
  text-decoration: none;
  font-size: 0.95rem;
  line-height: 1.35;
  display: block;
}

.fe-cart-product__name:hover {
  color: var(--fe-accent, #d4a000);
}

.fe-cart-product__price-sm {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #475569;
  font-variant-numeric: tabular-nums;
}

.fe-cart-money {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: #334155;
}

.fe-cart-money--strong {
  font-weight: 800;
  color: #0f172a;
}

.fe-cart-money--lg {
  font-size: 1.35rem;
  font-weight: 800;
  color: #0f172a;
}

/* Quantity */
.fe-qty {
  display: inline-flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.fe-qty__btn {
  width: 36px;
  height: 40px;
  border: none;
  background: #f8fafc;
  color: #334155;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  line-height: 1;
  transition: background 0.15s ease, color 0.15s ease;
}

.fe-qty__btn:hover {
  background: color-mix(in srgb, var(--fe-accent, #fcbe00) 12%, #fff);
  color: #0f172a;
}

.fe-qty__input {
  width: 52px;
  height: 40px;
  border: none;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 700;
  color: #0f172a;
  -moz-appearance: textfield;
}

.fe-qty__input::-webkit-outer-spin-button,
.fe-qty__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.fe-cart-remove {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: #fff5f5;
  color: #b91c1c;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.1s ease;
}

.fe-cart-remove:hover {
  background: #fee2e2;
  transform: scale(1.05);
}

/* Summary */
.fe-cart-summary__title {
  margin: 0 0 1.1rem;
  font-size: 1.05rem;
  font-weight: 800;
  color: #0f172a;
}

.fe-cart-card--summary {
  padding: 1.35rem 1.35rem 1.5rem;
}

.fe-cart-summary__lines {
  list-style: none;
  margin: 0 0 1.35rem;
  padding: 0;
  border: 1px solid #eef1f5;
  border-radius: 12px;
  overflow: hidden;
}

.fe-cart-summary__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 1.1rem;
  font-size: 0.92rem;
  color: #64748b;
  border-bottom: 1px solid #f1f5f9;
}

.fe-cart-summary__row:last-child {
  border-bottom: none;
}

.fe-cart-summary__row--total {
  background: #fafbfc;
  font-weight: 800;
  color: #0f172a;
  font-size: 1rem;
}

/* Buttons */
.fe-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.85rem 1.35rem;
  border-radius: 12px;
  font-weight: 800;
  font-size: 0.92rem;
  text-decoration: none;
  transition:
    transform 0.12s ease,
    box-shadow 0.2s ease,
    filter 0.15s ease;
  border: none;
  cursor: pointer;
}

.fe-btn--block {
  width: 100%;
  box-sizing: border-box;
}

.fe-btn--primary {
  background: linear-gradient(
    135deg,
    var(--fe-accent, #fcbe00) 0%,
    color-mix(in srgb, var(--fe-accent-hover, #e5ac00) 90%, #111) 100%
  );
  color: #ffffff;
  box-shadow: 0 8px 24px color-mix(in srgb, var(--fe-accent, #fcbe00) 35%, transparent);
  margin-bottom: 0.65rem;
}

.fe-btn--primary:hover {
  filter: brightness(1.03);
  box-shadow: 0 10px 28px color-mix(in srgb, var(--fe-accent, #fcbe00) 42%, transparent);
  color: #ffffff;
}

.fe-btn--ghost {
  background: #fff;
  color: #475569;
  border: 1px solid #e2e8f0;
  font-weight: 700;
}

.fe-btn--ghost:hover {
  border-color: var(--fe-accent, #fcbe00);
  color: #0f172a;
}

@media (max-width: 767.98px) {
  .fe-cart-table thead {
    display: none;
  }

  .fe-cart-table tbody tr {
    display: block;
    padding: 1rem 0;
    border-bottom: 1px solid #f1f5f9;
  }

  .fe-cart-table tbody td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
    border: none;
    padding: 0.4rem 1rem;
  }

  .fe-cart-table tbody td::before {
    content: attr(data-label);
    font-size: 0.65rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
  }

  .fe-cart-td--product {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .fe-cart-td--product::before {
    display: none;
  }

  .fe-cart-td--product .fe-cart-product {
    width: 100%;
  }

  .fe-cart-td--qty::before {
    align-self: center;
  }

  .fe-cart-td--rm::before {
    display: none;
  }

  .fe-cart-td--rm {
    justify-content: center !important;
    padding-top: 0.75rem !important;
  }
}
</style>